import React from 'react'

interface DirectionsIconProps {
  size?: number
  color?: string
}

const DirectionsIcon: React.FC<DirectionsIconProps> = ({
  size = 25,
  color,
}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M22.4274 10.5931L13.4174 1.5831C12.6674 0.833102 11.3474 0.823102 10.5874 1.5831L1.58744 10.5831C0.807441 11.3631 0.807441 12.6231 1.58744 13.4031L10.5874 22.4031C10.9774 22.7931 11.4874 22.9831 11.9974 22.9831C12.5074 22.9831 13.0174 22.7931 13.4074 22.4031L22.3974 13.4131C23.1874 12.6531 23.1974 11.3931 22.4274 10.5931ZM12.0074 20.9931L3.00744 11.9931L12.0074 2.9931L21.0074 11.9931L12.0074 20.9931ZM7.99744 11.0031V15.0031H9.99744V12.0031H13.9974V14.5031L17.4974 11.0031L13.9974 7.5031V10.0031H8.99744C8.44744 10.0031 7.99744 10.4531 7.99744 11.0031Z'
      fill={color || 'currentColor'}
    />
  </svg>
)

export default DirectionsIcon
